import { render, staticRenderFns } from "./downloadModal.vue?vue&type=template&id=0a6becf8&"
import script from "./downloadModal.vue?vue&type=script&lang=js&"
export * from "./downloadModal.vue?vue&type=script&lang=js&"
import style0 from "./downloadModal.vue?vue&type=style&index=0&id=0a6becf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports